/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const ElementH2Icon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="ElementH2Icon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <g>
              <path d="M3 4V12H4V9H7V12H8V4H7V8H4V4H3Z" fill="currentColor" />
              <path
                d="M10 7V5.5C10 4.67157 10.6716 4 11.5 4H12.5C13.328 4 13.9993 4.67092 14 5.49879V7.12546C13.9997 7.48837 13.8679 7.83888 13.6289 8.11202L11.1019 11H14V12H10V10.7407L12.8763 7.45352C12.956 7.36237 13 7.24538 13 7.12426V5.5C13 5.22386 12.7761 5 12.5 5H11.5C11.2239 5 11 5.22386 11 5.5V7H10Z"
                fill="currentColor"
              />
            </g>
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

ElementH2Icon.tags = [
  'heading',
  'h2',
  'text',
  'format',
  'typography',
  'font',
  'style',
];

ElementH2Icon.category = 'Navigator';

ElementH2Icon.iconSize = 16;
